// Derived values are NEVER stored — always computed at render time.
import { DAY_MS, localToday, toDate } from './local-date'
import { isShippedOrParked } from './stage'

export function daysBetween(from: string, to: Date): number {
  const start = toDate(from)
  if (Number.isNaN(start.getTime())) return 0
  return Math.max(0, Math.floor((to.getTime() - start.getTime()) / DAY_MS))
}

/**
 * Days at the current stage. `stageChangedAt` comes from the most recent
 * Stage field-change timeline event when available; created date otherwise.
 */
export function daysAtStage(
  stageChangedAt: string | null,
  createdAt: string,
  today: Date = localToday(),
): number {
  return daysBetween(stageChangedAt ?? createdAt, today)
}

/** Days past target date; null when not overdue or when the stage exempts it. */
export function daysOverdue(
  targetDate: string | null,
  stage: string | null,
  today: Date = localToday(),
): number | null {
  if (!targetDate) return null
  if (isShippedOrParked(stage)) return null
  const days = Math.floor((today.getTime() - toDate(targetDate).getTime()) / DAY_MS)
  return days > 0 ? days : null
}

export function daysAtReleased(releasedAt: string | null, today: Date = localToday()): number | null {
  if (!releasedAt) return null
  return daysBetween(releasedAt, today)
}

/** Stages where a long stay is a smell (flame icon when >= 7 days). */

export const HOT_THRESHOLD_DAYS = 7

export function isHot(days: number, stage: string | null): boolean {
  if (isShippedOrParked(stage) || stage === 'Waiting') return false
  return days >= HOT_THRESHOLD_DAYS
}
